import { Inject, Pipe, PipeTransform } from "@angular/core";

import { GLOBAL_CONFIG } from "../../const";
import { DeviceUtil } from "../../device/device.util";
import { GlobalConfig } from "../../model";

@Pipe({
	name: "devicePostfix",
})
export class DevicePostfixPipe implements PipeTransform {
	constructor(@Inject(GLOBAL_CONFIG) private globalConfig: GlobalConfig) {}

	transform(value: string): string {
		const deviceType = this.globalConfig.environmentContext.deviceType;
		return DeviceUtil.getDeviceSpecificCrsKey(value, deviceType);
	}
}
